import script from "./Gpon.vue?vue&type=script&setup=true&lang=js"
export * from "./Gpon.vue?vue&type=script&setup=true&lang=js"

import "./Gpon.vue?vue&type=style&index=0&id=06fea20e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fea20e"]])

export default __exports__